module.exports = __webpack_public_path__ + "img/vetsGo_White.5a91df10.svg";